<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  viewTransition?: boolean
  text: string
  class?: HTMLAttributes['class']
  center?: boolean
}>()
</script>
<template>
  <p
    v-if="props.text"
    :class="
      cn(
        'text-current/80 text-sm max-lg:font-medium lg:text-lg',
        {
          'lg:mx-auto': props.center
        },
        props.class
      )
    "
    :style="
      props.viewTransition
        ? {
            viewTransitionName: 'section-description'
          }
        : {}
    "
    v-html="props.text"
  />
</template>
